import LGCollectionContainer from './Container'
import LGCollectionsListContainer from './CollectionsList'

export default {
    LGCollectionContainer,
    LGCollectionsListContainer
}